import React, { useState, useEffect } from 'react';
import { Copy, Share2, Check, ExternalLink } from 'lucide-react';

const ReferralShareButton = () => {
  const [referralUrl, setReferralUrl] = useState('');
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Fetch user's referral URL when component mounts
    fetchReferralUrl();
  }, []);

  const fetchReferralUrl = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;

      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/referral/my-url`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setReferralUrl(data.referral_url);
      }
    } catch (error) {
      console.error('Error fetching referral URL:', error);
    }
  };

  const shareReferralUrl = async () => {
    if (!referralUrl) return;

    setLoading(true);
    
    const shareData = {
      title: 'Get $5 Credit on Shot Clock Dating!',
      text: `💰 Join Shot Clock Dating via my link and we both get $5 credits! Experience AI-powered speed dating with real connections. 💕`,
      url: referralUrl
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        // Fallback to copying the URL
        await navigator.clipboard.writeText(referralUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 3000);
      }
    } catch (error) {
      console.error('Error sharing referral URL:', error);
      // Try copying as fallback
      try {
        await navigator.clipboard.writeText(referralUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 3000);
      } catch (copyError) {
        console.error('Copy fallback failed:', copyError);
      }
    } finally {
      setLoading(false);
    }
  };

  // Don't show button if user is not logged in
  const token = localStorage.getItem('token');
  if (!token) {
    return null;
  }

  return (
    <button 
      onClick={shareReferralUrl}
      disabled={loading || !referralUrl}
      className="text-white bg-gradient-to-r from-purple-500 to-indigo-500 hover:from-purple-600 hover:to-indigo-600 disabled:from-gray-500 disabled:to-gray-600 rounded-xl px-4 py-3 font-medium transition-all duration-300 hover:scale-105 shadow-lg flex items-center justify-center gap-2 sm:w-auto w-full disabled:cursor-not-allowed disabled:hover:scale-100"
      title="Share your referral link for $5 bonus credits"
    >
      {loading ? (
        <>
          <div className="animate-spin w-4 h-4 border-2 border-white border-t-transparent rounded-full"></div>
          <span className="hidden sm:inline">Loading...</span>
        </>
      ) : copied ? (
        <>
          <Check className="w-4 h-4 text-green-300" />
          <span className="hidden sm:inline text-green-300">Link Copied!</span>
          <span className="sm:hidden text-green-300">Copied!</span>
        </>
      ) : (
        <>
          <span className="text-lg">💰</span>
          {navigator.share ? (
            <Share2 className="w-4 h-4" />
          ) : (
            <Copy className="w-4 h-4" />
          )}
          <span className="hidden sm:inline">
            {navigator.share ? 'Share Link' : 'Copy Link'}
          </span>
          <span className="sm:hidden">
            {referralUrl ? 'Share $5' : 'Loading...'}
          </span>
        </>
      )}
    </button>
  );
};

export default ReferralShareButton;